import { Text, View } from '@react-pdf/renderer';
import styles from '../styles/styles';

interface DetailsProps {
    detailsHeader: string;
    detailsTableHeader: string[];
    detailsRows: [string, ...string[]][];
}

const Details = ({
    detailsHeader,
    detailsTableHeader,
    detailsRows
}: DetailsProps) => (
    <>
        {/* Header */}
        <View style={styles.row}>
            <Text style={styles.subHeader}>{detailsHeader}</Text>
        </View>
        <View style={styles.miniSpacer} />

        {/* Grid */}
        <View>
            {/* Header Row */}
            <View style={styles.tableRow}>
                {detailsTableHeader.map((label, idx) => {
                    return (
                        <View key={`header-${idx}`} style={styles.tableCol}>
                            <Text style={styles.label}>
                                {label}:
                            </Text>
                        </View>
                    )
                })}
            </View>

            {/* Data Rows */}
            {detailsRows.map((row, rowIndex) => (
                <View key={`row-${rowIndex}`} style={styles.tableRow}>
                    {row.map((cell, colIndex) => {
                        return (
                            <View
                                key={`cell-${rowIndex}-${colIndex}`}
                                style={styles.tableCol}
                            >
                                <Text>
                                    {cell}
                                </Text>
                            </View>
                        );
                    })}
                </View>
            ))}
        </View>
    </>
);

export default Details;